import { render, staticRenderFns } from "./ProfileGrid.vue?vue&type=template&id=f5d2c9a8&scoped=true&"
import script from "./ProfileGrid.vue?vue&type=script&lang=js&"
export * from "./ProfileGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGrid.vue?vue&type=style&index=0&id=f5d2c9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d2c9a8",
  null
  
)

export default component.exports